import { pathResolver } from 'components/shared/navigation/RoutedTabPanel/pathResolver';
import { useStyles } from 'components/shared/navigation/RoutedTabPanel/RoutedTabPanel.styles';
import { RoutedTabPanelProps, TabConfig } from 'components/shared/navigation/RoutedTabPanel/RoutedTabPanel.types';
import { push } from 'utils/navigation/navigate';
import React, { FC } from 'react';
import { Tabs, Tab } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { makePath } from 'utils/navigation/makePath';

export const RoutedTabPanel: FC<RoutedTabPanelProps> = ({ tabs }) => {
  const classes = useStyles();
  const location = useLocation();
  const tabValue = pathResolver(location.pathname, tabs);

  function handleChange(event: React.ChangeEvent<{}>, path: string) {
    push(path);
  }

  const singleTabRender = (tab: TabConfig, index: number) => {
    const path = makePath(tab.route, tab.routeParams);

    return <Tab label={tab.title} value={path} key={index} />;
  };

  return (
    tabValue && (
      <Tabs value={tabValue} onChange={handleChange} classes={classes}>
        {tabs.map(singleTabRender)}
      </Tabs>
    )
  );
};
